import type { BridgeToken } from "../../bridge";
import type {
  GetOneUsdActionId,
  GetOneUsdPairs,
  GetOneUsdTokenRef,
  ResolvedGetOneUsdRoute,
} from "../types";

export function getOneUsdTokenKey(token: GetOneUsdTokenRef): string {
  return `${token.chainId}:${token.address.toLowerCase()}`;
}

export function matchesGetOneUsdToken(
  token: BridgeToken,
  ref: GetOneUsdTokenRef,
): boolean {
  return getOneUsdTokenKey(token) === getOneUsdTokenKey(ref);
}

export function findGetOneUsdToken(
  tokens: BridgeToken[],
  ref?: GetOneUsdTokenRef,
): BridgeToken | undefined {
  if (!ref) return undefined;
  return tokens.find((token) => matchesGetOneUsdToken(token, ref));
}

/** Resolve an action's exact token allowlist without mutating adapter data. */
export function resolveGetOneUsdRoute(
  tokens: BridgeToken[],
  pairs: GetOneUsdPairs | undefined,
  action: Exclude<GetOneUsdActionId, "transfer">,
): ResolvedGetOneUsdRoute {
  if (!pairs) return { fromTokens: [], targetToken: undefined };

  const fromRefs =
    action === "swap" ? [pairs.swap.from] : pairs.bridge.from;
  return {
    fromTokens: fromRefs
      .map((ref) => findGetOneUsdToken(tokens, ref))
      .filter((token): token is BridgeToken => Boolean(token)),
    targetToken: findGetOneUsdToken(tokens, pairs.target),
  };
}

export function isGetOneUsdTargetAvailable(
  available: BridgeToken[],
  target: BridgeToken,
): boolean {
  return available.some(
    (token) =>
      token.chainId === target.chainId &&
      token.address.toLowerCase() === target.address.toLowerCase(),
  );
}
